import { hallBookingBillDeleteApi } from "../../api/hallBookingBill/hallBookingBillDeleteApi"

type PayloadShape = Parameters<typeof hallBookingBillDeleteApi>[0]

export async function hallBookingBillDeleteService(
	payload: PayloadShape,
	token?: null | string,
) {
	const result = await hallBookingBillDeleteApi(payload, token)
	return result
}
